import { Account } from 'crono-fe-common/types/account';
import TemplateType from 'crono-fe-common/types/enums/templateType';
import { DashboardTabType } from '../../pages/lists/dashboardTabType';
import { FC, PropsWithChildren, useContext, useState } from 'react';
import { TaskPageTab } from 'pages/taskBoard/taskPageTabType';
import { IntegrationTab } from 'pages/settings/Integrations/types';
import { NonExistingCompany } from '../../types/nonExistingCompany';
import { SearchContactTabFiltersType } from 'pages/find-new/sales-nav/contacts/find-new-sales-nav-contacts.model';
import { SearchCompanyTabFiltersType } from 'pages/find-new/sales-nav/companies/find-new-sales-nav-companies.model';
import { FindNewDatabase } from 'pages/find-new/components/FindNewDatabaseSelect';
import { MixRankCompanySearch } from 'pages/find-new/crono-db/companies/find-new-crono-db-companies.types';
import { MixRankContactSearch } from 'pages/find-new/crono-db/contacts/find-new-crono-db-contacts.types';
import { CustomLocationContext } from './contexts';

export interface ICustomLocationContext {
  customStateLocation: CustomStateLocation | null;
  setCustomStateLocation: React.Dispatch<
    React.SetStateAction<CustomStateLocation | null>
  >;
}

export type InitialTemplateModalState = {
  title?: string;
  subject?: string;
  language?: string;
  content?: string;
  templateType?: TemplateType;
};

export type InitialCompanyFindNew = Pick<
  Account,
  | 'linkedin'
  | 'linkedinNumericId'
  | 'name'
  | 'objectId'
  | 'website'
  | 'emailDomain'
>;

export interface CustomStateLocation {
  // Lists Page
  listsPageTabState?: DashboardTabType | null;

  // Find New Page
  initialTabFindNew?: 'company' | 'contact';
  initialDatabaseFindNew?: FindNewDatabase | null;
  initialNonExistingCompany?: NonExistingCompany | null;
  initialCompanyFindNew?: InitialCompanyFindNew[] | null;
  initialContactFilters?: Partial<SearchContactTabFiltersType> | null;
  initialCompanyFilters?: Partial<SearchCompanyTabFiltersType> | null;
  initialCompanyFiltersCronoDb?: Partial<MixRankCompanySearch> | null;
  initialContactFiltersCronoDb?: Partial<MixRankContactSearch> | null;

  // Tasks Page
  initialTabTasksPage?: TaskPageTab | null;
  initialFilterByTasksPage?: 'manual' | 'automatic' | 'inError' | null;

  // Settings Page
  initialIntegrationSettingsTab?: IntegrationTab | null;

  // Templates Page
  initialTemplateModalState?: InitialTemplateModalState | null;

  // Inbox Page
  initialProspectIdInbox?: string | null;

  // Deals Page
  initialPipelineIdDealsPage?: number | null;
}

const CustomLocationProvider: FC<PropsWithChildren> = ({ children }) => {
  const [customStateLocation, setCustomStateLocation] =
    useState<CustomStateLocation | null>(null);

  return (
    <CustomLocationContext.Provider
      value={{
        customStateLocation,
        setCustomStateLocation,
      }}
    >
      {children}
    </CustomLocationContext.Provider>
  );
};

export default CustomLocationProvider;

export function useCustomLocation() {
  const context = useContext(CustomLocationContext);
  if (context === undefined) {
    throw new Error(
      `useCustomLocation must be used within a CustomLocationProvider`,
    );
  }

  return context;
}
